/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Site component information
 */
export interface SiteComponentInfo { 
    /**
     * Site Type
     */
    type?: string;
    /**
     * Optional associated Cloud DVX identifier
     */
    cloudDvxId?: string;
    /**
     * Associated IRR identifier
     */
    irrId?: string;
    /**
     * Indicates whether the site component is online
     */
    isOnline?: boolean;
}

